import { Layout } from "@/components/layout";

export default function PrivacyPolicy() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Notice</h1>

        <div className="prose prose-pink max-w-none">
          <p className="text-gray-600 mb-8">Last updated: April 1, 2025</p>

          <h2 className="text-xl font-semibold mt-6 mb-4">What We Collect and Why</h2>
          <p>
            We collect your name, email, and how you use Vow Quiz to run and improve our platform, 
            manage your account, and respond to you. We also keep the quizzes you make.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Who We Share It With</h2>
          <p>
            We share your info with helpers who run our services, other users (if you share quizzes), 
            or the law if we have to.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Keeping It Safe</h2>
          <p>
            We work to keep your data safe, but no online service is 100% secure.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Your Choices</h2>
          <p>
            You can ask to see, change, or delete your info. Email us anytime.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Kids</h2>
          <p>
            Vow Quiz isn’t for kids under 13, and we don’t collect their info.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Updates</h2>
          <p>
            We’ll post changes here and update the date.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">Contact Us</h2>
          <p>
            Questions? Email privacy@vowquiz.com.
          </p>
        </div>
      </div>
    </Layout>
  );
}